import { render, staticRenderFns } from "./ParrotRegisters.vue?vue&type=template&id=696642d8&"
import script from "./ParrotRegisters.vue?vue&type=script&lang=ts&"
export * from "./ParrotRegisters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports